export const labelsReducer = (state = {loading: false, result: null, labels: []} , action) => {
    switch (action.type) {
        case 'LABEL_GET_SUCCESS':
            return {
                ...state,
                loading: false,
                labels: action.payload
            }
        case 'LABEL_REGISTER_SUCCESS':
            return {
                ...state,
                loading: false,
                result: action.payload.message,
                labels: action.payload.labels
            }
        case 'LABEL_RESET_RESULT':
            return {
                ...state,
                result: null
            }
        case 'LABEL_LOADING':
            return {
                ...state,
                loading: true
            }
        case 'LABEL_NOT_LOADING':
            return {
                ...state,
                loading: false
            }
        default:
            return state
    }
}

